import { Link, useParams } from 'react-router-dom';
import { findGroup, type SeasonView } from '../data.js';
import MatchCard from '../components/MatchCard.js';

/**
 * One session, opened from the season schedule. It is the same card the home screen shows
 * (§5a) and nothing else: one way to read a match, one set of controls for changing it, and
 * nothing above it repeating what its day line already says.
 */
export default function SessionDetail({
  view,
  playerId,
}: {
  view: SeasonView;
  playerId: string;
}) {
  const { groupId, date } = useParams();

  const group = findGroup(view, groupId ?? '');
  const session = group?.sessions.find((s) => s.date === date);
  if (!group || !session) {
    return (
      <>
        <BackLink />
        <p className="muted">That session isn't on the schedule.</p>
      </>
    );
  }

  return (
    <>
      <BackLink />
      <MatchCard view={view} group={group} session={session} playerId={playerId} />
    </>
  );
}

/** The way back to where this screen is opened from — the only screen that links to it. */
function BackLink() {
  return (
    <p className="back-link">
      <Link to="/season">
        <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
          <path
            d="M10 3L5 8l5 5"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        Season schedule
      </Link>
    </p>
  );
}
